export default {
  'actions.title': 'ACCIONES',
  'actions.search': 'Busca una Acción',
  'actions.description.defaultInitial': 'Acción inicial del proceso',
  'actions.description.completeInformation': 'Permite completar información mediante formularios',
  'config.form.isInitialForm': '¿Formulario Inicial?',
  'config.form.isHeaderDetailsVisible': '¿Detalles de Cabecera Visible?',
  'config.form.isVisibleInDetails': '¿Visible en vista detalle de solicitud?',
  'actions.form.isInitialAction': '¿Acción Inicial?',
  'actions.form.isAutoOpenEditOperationEnabled': '¿Abrir Automáticamente Operación Editar',
  'actions.form.saveButtonDisabled': '¿Ocultar Botón Guardar?',
  'actions.form.allowedAppClient': 'Aplicación Permitida',
  'actions.form.emailServerConfiguration': 'Servidor de Correo',

  'actions.form.name': 'Nombre',
  'actions.form.description': 'Descripción',
  'actions.form.displayTitle': 'Título a Mostrar',
  'actions.form.completeInformationForm': 'Formulario Completar Información',
  'actions.form.nextAction': 'Siguiente Acción',
  'actions.form.form': 'Formulario',
  'actions.form.isRejectControlEnabled': '¿Control de Rechazo Habilitado?',
  'actions.form.nextActionIfFalseId': 'Siguiente Acción(No)',
  'actions.form.maxRejectionCount': 'Máximo Número de Rechazos',
  'actions.form.minNumberOfRejections': 'Mínimo Número de Rechazos',
  'actions.form.isTooltipEnabled': '¿Tooltip Habilitado?',
  'actions.form.tooltip': 'Tooltip',
  'actions.form.isPDFGenerationEnabled': '¿Generación de PDF Habilitada?',
  'actions.form.isNotificationsEnabled': '¿Notificaciones Habilitadas?',
  'actions.form.isPDFAttachmentEnabled': '¿Adjuntar PDF en Correos?',
  'actions.form.notificationsFrequency': 'Frecuencia de Notificaciones',
  'actions.form.frequencyValue': 'Valor Frecuencia',
  'actions.form.isWebhookEnabled': '¿Webhook Habilitado?',
  'actions.form.isWebhookCurrentStepValidationEnabled': '¿Validar Paso Actual?',
  'actions.form.isInternalExecutionAllowed': '¿Permitir Ejecución Interna?',
  'actions.form.webhookUser': 'Usuario Operaciones Webhook',
  'actions.form.webApiConnection': 'Conexión API',
  'actions.form.connection': 'Conexión API',
  'actions.form.reason': 'Motivo',
  'actions.form.logicalOperator': 'Operador Lógico',
  'actions.form.databaseQuery': 'Consulta Base de Datos',
  'actions.form.dynamicEntity': 'Entidad Dinámica',
  'actions.form.dynamicEntityOperation': 'Operación',

  // DynamicEntityOperation
  'actions.form.select.Search': 'Búsqueda',
  'actions.form.select.Add': 'Adicionar',
  'actions.form.select.Modify': 'Modificar',
  'actions.form.select.Remove': 'Eliminar',
  'actions.form.select.Count': 'Contar',
  'actions.form.select.Sum': 'Sumar',
  'actions.form.select.Subtraction': 'Restar',
  'actions.form.select.Increment': 'Incrementar',
  'actions.form.select.Decrement': 'Decrementar',
  'actions.form.select.EvaluateFormula': 'Evaluar Fórmula',

  // SearchResultGroupingMode
  'actions.form.select.None': 'Ninguno',
  'actions.form.select.ResponseMapping': 'Mapeo de Respuesta',

  // SearchResultAllocationMode
  'actions.form.select.Ordered': 'Ordenado',
  'actions.form.select.Random': 'Aleatorio',

  // ColumnOrderDirection
  'actions.form.select.Ascending': 'Ascendente',
  'actions.form.select.Descending': 'Descendente',

  // ItemsAffected
  'actions.form.select.All': 'Todos',
  'actions.form.select.One': 'Uno',
  'actions.form.select.Custom': 'Personalizado',

  'actions.config.configurations': 'Configuraciones',
  'actions.config.approval': 'Aprobación',
  'actions.config.action-approval-general': 'Generales',
  'actions.config.action-approval-rejection': 'Rechazo',
  'actions.config.action-approval-deadline': 'Límite de Tiempo',
  'actions.config.action-approval-filters': 'Filtros',
  'actions.config.action-approval-filters-general': 'Generales',
  'actions.config.action-approval-filters-users': 'Usuarios',
  'actions.config.action-approval-filters-positions': 'Puestos',
  'actions.config.action-approval-filters-areas': 'Áreas',
  'actions.config.action-approval-filters-user-groups': 'Grupos de Usuarios',
  'actions.config.action-approval-filters-external-users': 'Usuarios Externos',
  'actions.config.action-approval-filters-agents': 'Agentes',
  'actions.config.action-approval-filters-user-extra-fields': 'Campos Extra Usuario',
  'actions.config.action-approval-filters-global-approvers': 'Filtros Globales de Aprobadores',
  'actions.config.action-approval-filters-form-field-user-approvers':
    'Filtros por Campos de Formulario',
  'actions.config.custom-notifications': 'Notificaciones Personalizadas',
  'actions.config.notifications-mapping-attachments': 'Notificaciones / Mapeos Adjuntos',
  'actions.config.email-template': 'Formato de Correo',
  'actions.config.pdf-template-generation-mapping': 'Mapeos Generación Formatos',
  'actions.config.form-complete-information': 'Formulario Completar Información',
  'actions.config.digital-signature-field-mapping': 'Mapeo Campos Firma Digital',
  'actions.config.response-status': 'Mapeo Código Respuesta Http / Acción Siguiente',
  'actions.config.api-call-send': 'Mapeos Envío API',
  'actions.config.api-call-response': 'Mapeos Respuesta API',
  'actions.config.webhook-mapping': 'Mapeos Parámetros Webhook',
  'actions.config.set-variable': 'Establecer Variables',
  'actions.config.set-form-field-value': 'Establecer Datos de Formularios',
  'actions.config.conditional': 'Condicional',
  'actions.config.action-entity-operation': 'Operación Entidad',
  'actions.config.action-scheduled-execution': 'Programación',

  'actions.form.minimumNumberOfApprovers': 'Mínimo Número de Aprobadores',
  'actions.form.isRejectionDisabled': '¿Rechazo Deshabilitado?',
  'actions.form.isCompletedOptionDisabled': '¿Desabilitar Botón Completar?',
  'actions.form.webhookToken': 'Url Webhook',

  'actions.form.isErrorControlEnabled': '¿Habilitar Control de Errores?',
  'actions.form.nextActionIfErrorId': 'Siguiente Acción (Error)',
  'actions.form.errorValueDestination': 'Destino Error',
  'actions.form.errorVariableDestinationId': 'Error - Variable Destino',
  'actions.form.errorFormDestinationId': 'Error - Formulario Destino',
  'actions.form.errorFieldDestinationId': 'Error - Campo Destino',

  'actions.form.filtersLogicalOperator': 'Operador Lógico para Filtros',
  'actions.form.filtersUserGroupsLogicalOperator': 'Operador Lógico para Grupos',

  'actions.form.isDeadlineEnabled': '¿Habilitar Control de Límite de Tiempo de Ejecución?',
  'actions.form.deadlineMeasureUnit': 'Unidad de Control de Tiempo',
  'actions.form.deadlineMeasureValue': 'Valor de Control de Tiempo',
  'actions.form.overdueOperation': 'Operación',
  'actions.form.nextActionIfOverdueId': 'Acción Siguiente',
  'actions.form.overdueOperationObservations': 'Observaciones',

  'actions.form.isTwoFactorApprovalEnabled': '¿Aprobación Two-Factor?',
  'actions.form.isForApplicantApprovalEnabled': '¿Aprobar por el Solicitante?',
  'actions.form.isApprovalByExternalUserEnabled': '¿Habilitar Aprobación por Usuario Externo?',
  'actions.form.isPositionEqualToApplicantPosition': '¿Filtrar por Puesto del Solicitante?',
  'actions.form.isAreaEqualToApplicantArea': '¿Filtrar por Área del Solicitante?',
  'actions.form.isForApplicantBossApprovalEnabled': '¿Aprobar por el Jefe del Solicitante?',
  'actions.form.isApproveByTheLastApproverEnabled': '¿Aprobar por Último Aprobador?',

  'actions.form.isGlobalUserGroupApproversFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Grupos de Usuarios?',
  'actions.form.globalUserGroupFilterFormId':
    'Formulario para Filtro Global de Aprobadores por Grupos de Usuarios',
  'actions.form.globalUserGroupFilterFieldId':
    'Campo para Filtro Global de Aprobadores por Grupos de Usuarios',
  'actions.form.isGlobalUserGroupApproversFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Grupos de Usuarios?',
  'actions.form.globalUserGroupApproversFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Grupos de Usuarios',

  'actions.form.isGlobalUserGroupPositionApproversFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Grupos de Usuarios y Puestos?',
  'actions.form.globalUserGroupFilterPositionFormId':
    'Formulario para Filtro Global de Aprobadores por Grupos de Usuarios y Puestos',
  'actions.form.globalUserGroupFilterPositionFieldId':
    'Campo para Filtro Global de Aprobadores por Grupos de Usuarios y Puestos',
  'actions.form.isGlobalUserGroupPositionApproversFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Grupos de Usuarios y Puestos?',
  'actions.form.globalUserGroupPositionApproversFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Grupos de Usuarios y Puestos',

  'actions.form.isGlobalUserGroupAreaApproversFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Grupos de Usuarios y Áreas?',
  'actions.form.globalUserGroupFilterAreaFormId':
    'Formulario para Filtro Global de Aprobadores por Grupos de Usuarios y Áreas',
  'actions.form.globalUserGroupFilterAreaFieldId':
    'Campo para Filtro Global de Aprobadores por Grupos de Usuarios y Áreas',
  'actions.form.IsGlobalEntityApproversByAreaFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Grupos de Usuarios y Áreas?s',
  'actions.form.globalUserGroupAreaApproversFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Grupos de Usuarios y Áreas',

  'actions.form.isGlobalEntityApproversFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Entidades y Usuarios?',
  'actions.form.globalEntityFilterFormId':
    'Formulario para Filtro Global de Aprobadores por Entidades',
  'actions.form.globalEntityFilterFieldId': 'Campo para Filtro Global de Aprobadores por Entidades',
  'actions.form.isGlobalEntityApproversFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades?',
  'actions.form.globalEntityApproversFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades',

  'actions.form.isGlobalEntityApproversByUserGroupFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Entidades y Grupos de Usuarios?',
  'actions.form.globalEntityFilterByUserGroupFormId':
    'Formulario para Filtro Global de Aprobadores por Entidades y Grupos de Usuarios',
  'actions.form.globalEntityFilterByUserGroupFieldId':
    'Campo para Filtro Global de Aprobadores por Entidades y Grupos de Usuarios',
  'actions.form.isGlobalEntityApproversByUserGroupFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades y Grupos de Usuarios?',
  'actions.form.globalEntityApproversByUserGroupFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades y Grupos de Usuarios',

  'actions.form.isGlobalEntityApproversByPositionFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Entidades y Puestos?',
  'actions.form.globalEntityFilterByPositionFormId':
    'Formulario para Filtro Global de Aprobadores por Entidades y Puestos',
  'actions.form.globalEntityFilterByPositionFieldId':
    'Campo para Filtro Global de Aprobadores por Entidades y Puestos',
  'actions.form.isGlobalEntityApproversByPositionFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades y Puestos?',
  'actions.form.globalEntityApproversByPositionFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades y Puestos',

  'actions.form.isGlobalEntityApproversByAreaFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Entidades y Áreas?',
  'actions.form.globalEntityFilterByAreaFormId':
    'Formulario para Filtro Global de Aprobadores por Entidades y Áreas',
  'actions.form.globalEntityFilterByAreaFieldId':
    'Campo para Filtro Global de Aprobadores por Entidades y Áreas',
  'actions.form.IsGlobalEntityApproversByAreaFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades y Áreas?',
  'actions.form.globalEntityApproversByAreaFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades y Áreas',

  'actions.form.isApproverByUserFormFieldFilterEnabled':
    '¿Habilitar Filtro de Usuario por Campo de Formulario?',
  'actions.form.approverByUserFormFieldFormId':
    'Formulario para Filtro de Usuario por Campo de Formulario',
  'actions.form.approverByUserFormFieldFieldId':
    'Campo para Filtro de Usuario por Campo de Formulario',

  'actions.form.isApproverByPositionFormFieldFilterEnabled':
    '¿Habilitar Filtro de Usuario por Campo Puesto de Formulario?',
  'actions.form.approverByPositionFormFieldFormId':
    'Formulario para Filtro de Usuario por Campo Puesto de Formulario',
  'actions.form.approverByPositionFormFieldFieldId':
    'Campo para Filtro de Usuario por Campo Puesto de Formulario',

  'actions.form.isApproverByAreaFormFieldFilterEnabled':
    '¿Habilitar Filtro de Usuario por Campo Área de Formulario?',
  'actions.form.approverByAreaFormFieldFormId':
    'Formulario para Filtro de Usuario por Campo Área de Formulario',
  'actions.form.approverByAreaFormFieldFieldId':
    'Campo para Filtro de Usuario por Campo Área de Formulario',

  'actions.form.isApproverByUserGroupFormFieldFilterEnabled':
    '¿Habilitar Filtro de Usuario por Campo Grupo de Usuarios de Formulario?',
  'actions.form.approverByUserGroupFormFieldFormId':
    'Formulario para Filtro de Usuario por Campo Grupo de Usuarios de Formulario',
  'actions.form.approverByUserGroupFormFieldFieldId':
    'Campo para Filtro de Usuario por Campo Grupo de Usuarios de Formulario',

  'action.config.select.ReadOnly': 'Solo Lectura',
  'action.config.select.Hidden': 'Oculto',
  'action.config.select.Visible': 'Visible',
  'action.config.select.Required': 'Requerido',
  'action.config.select.NotRequired': 'No Requerido',
  'action.config.select.VisibleAndSkipFormulaEvaluation': 'Visible and Skip Formula Evaluation',
  'action.config.select.HiddenAndSkipFormulaEvaluation': 'Oculto y Omitir Evaluación de Fórmula',

  'action.config.select.formField': 'Formulario / Campo',
  'action.config.select.variable': 'Variable',

  'action.config.select.And': 'AND',
  'action.config.select.Or': 'OR',

  'action.config.select.rejectRequest': 'Rechazar Solicitud',
  'action.config.select.cancelarSolicitud': 'Cancelar Solicitud',
  'action.config.select.executeAction': 'Ejecutar Acción',
  'action.generate.ai.coming.soon': 'Genera IA Próximamente',
  'action.Enter.some.text.here': 'Introzca algún texto aquí...',
  'action.config.beautify': 'Embellecer',
  'action.config.beautify.loading.title': 'Embelleciendo tu diagrama',
  'action.config.beautify.loading.subtitle':
    'Estamos organizando cada conexión para que el flujo luzca impecable. Solo tomará un momento.',
  'action.config.diagram.loading.title': 'Cargando el diagrama',
  'action.config.diagram.loading.subtitle':
    'Estamos preparando cada acción y conexión para mostrarte el flujo con total claridad.',

  // New fields for all ActionTypes
  'actions.form.process': 'Proceso',
  'actions.form.actionToExecute': 'Acción a Ejecutar',
  'actions.form.sequence': 'Secuencia',
  'actions.form.rpaAgent': 'Agente RPA',
  'actions.form.rpaFlow': 'Flujo RPA',
  'actions.form.integration': 'Integración',
  'actions.form.integrationFunction': 'Función',
  'actions.form.operationType': 'Tipo de Operación',
  'actions.form.model': 'Modelo',
  'actions.form.serviceType': 'Tipo de Servicio',
  'actions.form.sharePointOperation': 'Tipo de Operación',
  'actions.form.ftpOperationType': 'Tipo de Operación',
  'actions.form.programmingLanguage': 'Lenguaje',
  'actions.form.whatsAppBusinessOperationType': 'Tipo de Operación',

  // DynamicEntityOperation fields
  'actions.form.dynamicEntity': 'Entidad Dinámica',
  'actions.form.dynamicEntityOperation': 'Tipo de Operación',
  'actions.form.searchResultGroupingMode': 'Modo de Agrupación',
  'actions.form.searchResultAllocationMode': 'Modo de Asignación',
  'actions.form.sortField': 'Campo para Ordenar',
  'actions.form.sortDirection': 'Modo de Ordenamiento',
  'actions.form.itemsAffected': 'Elementos Afectados',
  'actions.form.customItemsAffectedNumber': 'Cantidad de Elementos',

  // ScheduledExecution fields
  'actions.form.scheduledExecutionType': 'Tipo de Ejecución Programada',
  'actions.form.delayFrequency': 'Frecuencia de Espera',
  'actions.form.delayFrequencyValue': 'Valor Frecuencia de Espera',
  'actions.form.executionHour': 'Hora de Ejecución',
  'actions.form.executionDayOfWeek': 'Día de La Semana',
  'actions.form.executionMonth': 'Mes de Ejecución',
  'actions.form.executionMonthDay': 'Día del Mes',
  'actions.form.delayUntilFieldValueForm': 'Espera / Formulario',
  'actions.form.delayUntilFieldValueField': 'Espera / Campo',
  'actions.form.delayUntilVariableValueVariable': 'Espera / Variable',

  // ActionScheduledExecutionType
  'actions.form.select.Delay': 'Espera',
  'actions.form.select.DelayUntil': 'Esperar Hasta',
  'actions.form.select.DelayUntilFieldValue': 'Esperar Hasta Valor de Campo',
  'actions.form.select.DelayUntilVariableValue': 'Esperar Hasta Valor de Variable',

  // Validation messages for scheduled execution
  'actions.validation.integerMinValue': 'Debe ser un número entero mayor o igual a {min}',
  'actions.validation.integerRange': 'Debe ser un número entero entre {min} y {max}',

  // FrequencyUnit
  'actions.form.select.Minute': 'Minuto',
  'actions.form.select.Hour': 'Hora',
  'actions.form.select.Day': 'Día',
  'actions.form.select.Month': 'Mes',

  // DayOfWeek
  'actions.form.select.Sunday': 'Domingo',
  'actions.form.select.Monday': 'Lunes',
  'actions.form.select.Tuesday': 'Martes',
  'actions.form.select.Wednesday': 'Miércoles',
  'actions.form.select.Thursday': 'Jueves',
  'actions.form.select.Friday': 'Viernes',
  'actions.form.select.Saturday': 'Sábado',
  'actions.form.select.Weekend': 'Fin de Semana',
  'actions.form.select.Weekday': 'Día de Semana',

  // MonthName
  'actions.form.select.January': 'Enero',
  'actions.form.select.February': 'Febrero',
  'actions.form.select.March': 'Marzo',
  'actions.form.select.April': 'Abril',
  'actions.form.select.May': 'Mayo',
  'actions.form.select.June': 'Junio',
  'actions.form.select.July': 'Julio',
  'actions.form.select.August': 'Agosto',
  'actions.form.select.September': 'Septiembre',
  'actions.form.select.October': 'Octubre',
  'actions.form.select.November': 'Noviembre',
  'actions.form.select.December': 'Diciembre',

  // ActionOverdueOperation
  'actions.form.select.RejectProcessInstance': 'Rechazar Solicitud',
  'actions.form.select.CancelProcessInstance': 'Cancelar Solicitud',
  'actions.form.select.ExecuteAction': 'Ejecutar Acción',

  // ExternalUserValueSource
  'actions.form.select.FormField': 'Campo de Formulario',
  'actions.form.select.Variable': 'Variable',
  'actions.form.select.FixedValue': 'Valor Fijo',

  // Approval - General
  'actions.form.minApproversCount': 'Mínimo Número de Aprobadores',
  'actions.form.twoFactorApprovalEnabled': '¿Aprobación Two-Factor?',

  // Approval - Rejection
  'actions.form.disableReject': '¿Rechazo Deshabilitado?',
  'actions.form.controlRejection': '¿Control de Rechazo?',
  'actions.form.minRejectionCount': 'Mínimo Número de Rechazos',
  'actions.form.maxRejectionCount': 'Máximo Número de Rechazos',

  // Approval - Deadline
  'actions.form.enabled': '¿Habilitar?',
  'actions.form.delayType': 'Tipo de Ejecución Programada',
  'actions.form.measureUnit': 'Frecuencia de Espera',
  'actions.form.measureValue': 'Valor Frecuencia de Espera',
  'actions.form.delayHour': 'Hora de Ejecución',
  'actions.form.delayDayOfWeek': 'Día de La Semana',
  'actions.form.delayMonthDay': 'Día del Mes',
  'actions.form.delayMonth': 'Mes de Ejecución',
  'actions.form.delayUntilFieldValueForm': 'Espera / Formulario',
  'actions.form.delayUntilFieldValueField': 'Espera / Campo',
  'actions.form.delayUntilVariableValueVariable': 'Espera / Variable',

  // Approval - Filters General
  'actions.form.applicantApprovalEnabled': '¿Aprobar por el Solicitante?',
  'actions.form.approveByApplicantBoss': '¿Aprobar por el Jefe del Solicitante?',
  'actions.form.approveByLastApprover': '¿Aprobar por el Último Aprobador?',
  'actions.form.approveByLastRejectionUser': '¿Aprobar por el Último Rechazador?',
  'actions.form.approveByLastRevisionUser': '¿Aprobar por el Último Revisor?',
  'actions.form.filterByApplicantPosition': '¿Filtrar por Puesto del Solicitante?',
  'actions.form.filterByApplicantArea': '¿Filtrar por Área del Solicitante?',
  'actions.form.filterByApplicantUserGroups': '¿Filtrar por Grupos del Solicitante?',
  'actions.form.allowExternalUserApproval': '¿Habilitar Aprobación por Usuario Externo?',

  // Approval - Filters (Lists)
  'actions.form.users': 'Usuarios',
  'actions.form.positions': 'Puestos',
  'actions.form.areas': 'Áreas',
  'actions.form.userGroups': 'Grupos de Usuarios',
  'actions.form.aiAgents': 'Agentes',

  // External Users
  'actions.form.valueSource': 'Origen',
  'actions.form.sourceForm': 'Formulario',
  'actions.form.sourceField': 'Campo',
  'actions.form.sourceVariable': 'Variable',
  'actions.form.fixedValue': 'Valor Fijo',

  // User Extra Fields
  'actions.form.userExtraField': 'Campo Extra',
  'actions.form.filterValue': 'Valor de Filtro',

  // Global Approvers
  'actions.form.userGroupApprovers': 'Filtro Global de Aprobadores por Grupos de Usuarios',
  'actions.form.userGroupPositionApprovers':
    'Filtro Global de Aprobadores por Grupos de Usuarios y Puestos',
  'actions.form.userGroupAreaApprovers':
    'Filtro Global de Aprobadores por Grupos de Usuarios y Áreas',
  'actions.form.entityUsersApprovers': 'Filtro Global de Aprobadores por Entidades y Usuarios',
  'actions.form.entityPositionUsersApprovers':
    'Filtro Global de Aprobadores por Entidades y Puestos',
  'actions.form.entityAreaUsersApprovers': 'Filtro Global de Aprobadores por Entidades y Áreas',
  'actions.form.entityUserGroupUsersApprovers':
    'Filtro Global de Aprobadores por Entidades y Grupos de Usuarios',
  'actions.form.approvalLevelEnabled': '¿Habilitar Nivel de Filtro?',
  'actions.form.approvalLevel': 'Nivel de Filtro',
  'actions.form.field': 'Campo',

  // Form Field User Approvers
  'actions.form.userApprovers': 'Filtro de Usuario por Campo de Formulario',
  'actions.form.positionApprovers': 'Filtro de Usuario por Campo Puesto de Formulario',
  'actions.form.areaApprovers': 'Filtro de Usuario por Campo Área de Formulario',
  'actions.form.userGroupApprovers': 'Filtro de Usuario por Campo Grupo de Usuarios de Formulario',

  // LogicalOperator
  'actions.form.select.Or': 'O',
  'actions.form.select.And': 'Y',

  'action.canvas.zoomIn': 'Acercar',
  'action.canvas.pan': 'Mover lienzo',
  'action.canvas.select': 'Seleccionar elementos',
  'action.canvas.zoomLabel': 'Zoom',
};
